(function () {
  'use strict';

  class DecoratedVideoPlayerService {
    constructor(safetyService, $document, $rootScope, $window) {
      this.safetyService = safetyService;
      this.document = $document[0];
      this.window = $window;
      this.coachingStatus = 'UNDECIDED';
      this.rootScope = $rootScope;
      this.addCloseListener();
      this.addCoachRequiredListener();
      this.addCommentListener();
    }

    addCommentListener() {
      this.window.addEventListener('commentSavedEvent', (event) => {
        if (event && event.detail) {
          const {vehicleId, datahora, comment} = event.detail;
          this.rootScope.$applyAsync(() => {
            this.rootScope.$emit('commentSavedEvent', {vehicleId, datahora, comment});
          });
        }
      });
    }

    addCoachRequiredListener() {
      this.window.addEventListener('coachRequiredEvent', (event) => {
        if (event && event.detail) {
          this.coachingStatus = event.detail.coachingStatus;
          this.rootScope.$applyAsync(() => {
            this.rootScope.$emit('coachRequiredUpdated', this.coachingStatus);
          });
        }
      });
    }

    addCloseListener() {
      this.rootScope.$on('closeDecoratedVideoPlayer', () => {
        this.safetyService.unmountReactComponent('decoratedVideoPlayerModalContainer');
        this.rootScope.$emit('updateDecoratedVideoPlayer');
      });
    }

    loadDecoratedVideoPlayer(props, isSeparatedVideoScreen = false) {
      const appName = 'safetyApp',
          componentPath = './VideoPlayerModal',
          componentId = 'decoratedVideoPlayerModalContainer';

      if (this.document.getElementById(componentId)) {
        this.safetyService.unmountReactComponent(componentId);
      }

      if (!isSeparatedVideoScreen) {
        props.onCloseDecoratedVideoPlayer = () => {
          this.rootScope.$apply(() => {
            this.rootScope.$emit('closeDecoratedVideoPlayer');
            this.window.parent.postMessage({event: 'closeDecoratedVideoPlayer'});
            if (
              this.coachingStatus === 'COACHING_REQUIRED' ||
              this.coachingStatus === 'NO_COACHING_REQUIRED' ||
              this.coachingStatus === 'UNDECIDED' ||
              this.coachingStatus === 'DISMISSED' ||
              this.coachingStatus === 'COMPLETED'
            ) {
              this.rootScope.$emit('updateTable', {
                vehicleId: props.vehicleId,
                datahora: props.datahora,
                coachingStatus: this.coachingStatus
              });
            }
          });
        };
      }

      this.safetyService.loadReactComponent(appName, componentPath, componentId, props)
        .catch(error => console.error('Error loading Decorated Video Player:', error));
    }
  }

  DecoratedVideoPlayerService.$inject = ['safetyService', '$document', '$rootScope', '$window'];

  angular
    .module('videoPlayer')
    .service('DecoratedVideoPlayerService', DecoratedVideoPlayerService);
})();
